<template>
  <div class="forum">
    <div class="forum-box" :class="{ 'no-mart': $identity.name !== 'student' }">
      <div class="left">
        <div v-if="group.length > 0" class="group-box">
          <p class="title">
            <span>热门圈子</span>
            <router-link class="more" :to="{ name: 'CommunityGroup' }">
              更多
            </router-link>
          </p>
          <div class="group">
            <el-row :gutter="42">
              <el-col :span="8" v-for="item in group" :key="item.id">
                <div class="grid-content" @click="toCircle(item.id)">
                  <div class="img-wrap">
                    <img
                      class="img"
                      :src="item.image"
                      @load="onGroupImageLoad"
                    />
                  </div>
                  <div class="content">
                    <p class="name eps">{{ item.name }}</p>
                    <div class="message">
                      <p class="comment">
                        <span>帖子{{ item.post_num }}</span>
                      </p>
                      <p class="people">
                        <span>成员{{ item.user_num }}</span>
                      </p>
                    </div>
                    <p
                      class="isJoin"
                      @click.stop="toJoin(item.id, item.is_user_add)"
                      v-if="item.is_user_add == 2"
                    >
                      + 加入
                    </p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="bbs-box">
          <!-- 版块 -->
          <el-tabs
            class="el-tabs-commounity el-tabs-community-active"
            v-model="plate_id"
          >
            <el-tab-pane
              :label="item.name"
              :name="String(item.id)"
              v-for="item in blocks"
              :key="item.id"
            ></el-tab-pane>
          </el-tabs>
          <div class="select">
            <SelectItem
              :items="selectItems"
              @handleClick="handleClick"
            ></SelectItem>
          </div>
          <ul class="forum-list">
            <CommunityCircleItem
              @complaint="onComplaint"
              :plate_id="String(plate_id)"
              :activeTab="activeTab"
              origin="2"
            ></CommunityCircleItem>
          </ul>
        </div>
      </div>
      <div class="right">
        <div class="mine m-group">
          <div class="header">
            <p class="title">我的圈子</p>
            <div class="more" @click="toMemberCommunity('3')">
              <p>更多</p>
              <img src="@/assets/images/community/icon_more.png" alt="" />
            </div>
          </div>
          <p class="no-login" v-if="$store.state.token && !myGroup.length">
            <span class="emptyTip">暂无圈子～</span>
          </p>
          <router-link
            v-if="!$store.state.token"
            class="no-login"
            :to="{ name: 'Login' }"
          >
            <span>登录</span>
            后才能查看哦～
          </router-link>
          <div v-else class="login">
            <router-link
              v-for="item in myGroup"
              :key="item.group_id"
              class="grid-content"
              :to="{ name: 'CommunityGroupShow', params: { id: item.id } }"
            >
              <div class="img">
                <img :src="item.image" />
              </div>
              <div class="content">
                <p class="name">{{ item.name }}</p>
                <div class="message">
                  <p class="comment">
                    <span>帖子{{ item.post_num }}</span>
                  </p>
                  <p class="people">
                    <span>成员{{ item.user_num }}</span>
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <SectionRight
          :recommend="myCollect"
          title="我的收藏"
          showMore
          @toOtherDetail="toOther"
          @seeMore="toMemberCommunity('2')"
          tip="暂无收藏～"
        />
        <SectionRight
          :recommend="myPost"
          title="我的帖子"
          showMore
          @toOtherDetail="toOther"
          @seeMore="toMemberCommunity"
          class="myPost"
          tip="暂无帖子～"
        />
      </div>
    </div>
    <Complaint ref="complaint"></Complaint>
  </div>
</template>

<script>
import CommunityCircleItem from "./components/CommunityCircleItem";
import Complaint from "./components/Complaint.vue";
import SectionRight from "./components/SectionRight";
import SelectItem from "./components/SelectItem";
export default {
  name: "Community",
  components: { CommunityCircleItem, Complaint, SectionRight, SelectItem },
  data() {
    return {
      plate_id: "all", //已选版块
      selectItems: [
        { key: "hot", title: "最热" },
        { key: "new", title: "最新" },
      ],
      blocks: [], //版块
      activeTab: "hot", //最热/最新
      group: [], //获取小组列表
      topicCount: {}, //总发帖量
      myGroup: [], //我的小组
      myPost: [], //我的参与
      myCollect: [], //我的收藏
      schoolId: localStorage["studentSchool"],
    };
  },
  async created() {
    await this.getGroupList();
    await this.getPostNum();
    if (this.$store.state.token) {
      await this.getMineGroup();
      await this.getMinePost();
      await this.getMineCollect();
    }
  },
  mounted() {
    //模块列表
    this.$http
      .get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/plate`,
        {
          group_id: "community",
        },
      )
      .then(res => {
        this.blocks = res || [];
        this.blocks.unshift({ id: "all", name: "全部" });
      });
  },
  methods: {
    // 热门最新话题切换
    handleClick(data) {
      this.activeTab = data;
    },
    // 获取小组列表
    async getGroupList() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/group`,
        {
          limit: 6,
          hot: 1,
        },
      );
      that.group = data.data.splice(0, 3);
    },
    //跳转圈子
    toCircle(id) {
      this.$router.push({
        name: "CommunityGroupShow",
        params: { id },
      });
    },
    //加入/退出圈子
    async toJoin(id, isAdd) {
      if (isAdd == 1) {
        await this.$http.get(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/outGroup/${id}`,
        );
      } else {
        await this.$http.get(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/addGroup/${id}`,
        );
      }
      this.getGroupList();
      this.getMineGroup();
    },
    // 获取发布数量
    async getPostNum() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/statistics`,
      );
      that.topicCount = data;
    },

    // 获取我的小组
    async getMineGroup() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/group/myGroup`,
        { group_type: 2, school_id: this.schoolId },
      );
      that.myGroup = data.data.slice(0, 2);
    },

    // 获取我的帖子
    async getMinePost(limit) {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/myPost`,
        {
          page: 1,
          limit: limit ? limit : 2,
          group_type: 2,
          school_id: this.schoolId,
        },
      );
      that.myPost = data.data.slice(0, 5);
    },

    // 我的收藏
    async getMineCollect() {
      let data = await this.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/collect`,
        { group_type: 2, school_id: this.schoolId },
      );
      this.myCollect = data.data.slice(0, 2);
    },
    // 跳转
    toMemberCommunity(tab) {
      if (this.$store.state.token) {
        this.$router.push({
          name: "MemberCommunity",
          query: {
            tab,
          },
        });
      } else {
        this.$router.push({
          name: "Login",
        });
      }
    },
    //跳转其他帖子
    toOther(item) {
      this.$router.push({
        name: "CommunityDetail",
        params: {
          id: item.post_id,
          group_id: item.group_id,
          type: 2,
        },
      });
    },
    onGroupImageLoad($event) {
      let width = $event.target.naturalWidth;
      let height = $event.target.naturalHeight;
      if (width < 72 || height < 72) {
        return;
      }
      let widthPercent = 72 / width;
      let heightPercent = 72 / height;
      let percent = widthPercent > heightPercent ? widthPercent : heightPercent;
      width = parseInt(width * percent);
      height = parseInt(height * percent);
      $event.target.style.width = width + "px";
      $event.target.style.height = height + "px";
    },
    onComplaint(item) {
      this.$refs.complaint.show(4, item.id);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.forum {
  padding-bottom: 24px;
  overflow: hidden;
  /deep/ {
    .el-pagination {
      margin: 25px 0;
    }
  }
  .forum-box {
    overflow: hidden;
    width: 100%;
    margin: 16px auto 0;
    &.no-mart {
      margin-top: 0;
    }
    .left {
      float: left;
      width: 896px;
      overflow: hidden;
      .group-box {
        background: #fff;
        padding: 13px 24px 24px 24px;
        margin-bottom: 16px;
        border-radius: 4px;
        .title {
          display: flex;
          justify-content: space-between;
          height: 30px;
          line-height: 30px;
          span {
            font-size: 16px;
            color: #20242a;
          }
          a {
            padding-right: 11px;
            background: url("~@/assets/images/icon_fourm_right_arrow.png") right
              9px no-repeat;
            background-size: 6px 11px;
            font-size: 14px;
            color: #666;
          }
        }
        .group {
          margin-top: 13px;
          .el-row {
            margin: 0 !important;
          }
          .el-col {
            border: 1px solid #e6e6e6;
            border-radius: 5px;
            padding: 0 !important;
            margin-right: 22px;
            width: auto !important;
            height: 112px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            &:nth-child(3n) {
              margin-right: 0;
            }
            &:hover {
              box-shadow: 0px 1px 10px 0px #ebebeb;
              border-color: transparent;
            }
            .grid-content {
              width: 266px;
              box-sizing: border-box;
              position: relative;
              top: 0;
              padding: 0 15px;
              border-radius: 4px;
              cursor: pointer;
              background-color: #fff;
              overflow: hidden;
              display: flex;
              align-items: center;
              .img-wrap {
                float: left;
                width: 72px;
                height: 72px;
                border-radius: 4px;
                overflow: hidden;
                flex-shrink: 0;
                border: 1px solid #e7e7e7;
                box-sizing: border-box;
              }
              .img {
                border-radius: 4px;
              }
              .content {
                margin-left: 15px;
                width: auto;
                overflow: hidden;
                align-self: flex-start;
                .name {
                  height: 22px;
                  font-size: 14px;
                  font-weight: 500;
                  color: rgba(32, 36, 42, 1);
                  line-height: 22px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  margin-bottom: 4px;
                }
                .message {
                  display: flex;
                  font-size: 13px;
                  color: #999;
                  .comment {
                    margin-right: 8px;
                  }
                }
                .isJoin {
                  font-size: 14px;
                  color: $primary-color;
                  padding-top: 10px;
                  cursor: pointer;
                }
              }
              .btn {
                position: absolute;
                left: 50%;
                bottom: -13px;
                display: none;
                width: 66px;
                height: 26px;
                margin-left: -33px;
                border-radius: 14px;
                background-color: $primary-color;
                text-align: center;
                font-size: 13px;
                color: #fff;
                line-height: 26px;
              }
            }
          }
        }
      }

      .bbs-box {
        background-color: #fff;
        overflow: hidden;
        padding: 12px 24px 0;
        position: relative;
        border-radius: 4px;
        .forum-list {
          box-sizing: border-box;
        }
        .select {
          position: absolute;
          top: 32.5px;
          right: 25px;
          transform: translateY(-50%);
          display: flex;
          align-items: center;
          .label {
            margin-right: 10px;
          }
        }
      }
    }
    .right {
      margin-left: 912px;
      width: auto;
      .look-day {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 135px;
        background: #fff;
        div {
          flex: 1;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        .today {
          position: relative;
          &::after {
            content: "";
            width: 1px;
            height: 40px;
            background-color: #edf1f2;
            position: absolute;
            right: 0;
            top: 47px;
          }
        }
        .num {
          margin: 0 0 15px;
          font-size: 30px;
          color: #666;
          line-height: 30px;
        }
        .day {
          line-height: 16px;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          color: #b7b7b7;
        }
      }
      .post {
        display: block;
        width: 100%;
        margin: 20px 0 0;
        padding: 0 0 0 130px;
        height: 60px;
        line-height: 60px;
        border: none;
        box-shadow: 0px 6px 20px 0px $primary-color-04,
          0px 13px 33px 0px rgba(0, 0, 0, 0.04);
        border-radius: 32px;
        background: url("~@/assets/images/icon_fourm_post.png") 180px center
          no-repeat #fff;
        background-size: 18px 18px;
        text-align: left;
        font-size: 20px;
        color: #595959;
        outline: none;
        cursor: pointer;
        &:hover {
          background: url("~@/assets/images/icon_fourm_post_active.png") 180px
            center no-repeat $primary-color;
          background-size: 18px 18px;
          color: #fff;
        }
      }
      .mine {
        padding: 16px;
        background-color: #fff;
        margin-bottom: 16px;
        border-radius: 4px;
        .title {
          position: relative;
          font-size: 16px;
          color: #333;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 14px;
            color: #666;
            margin-right: 10px;
            font-weight: 400;
          }
        }
        .no-login {
          display: block;
          height: 147px;
          background: url("~@/assets/images/community/no_login_bg.png") center
            no-repeat #fff;
          background-size: 221px 154px;
          line-height: 250px;
          text-align: center;
          font-size: 14px;
          color: #999;
          margin-top: 20px;
          span {
            color: $primary-color;
            margin-left: 22px;
          }
          .emptyTip {
            color: #999;
          }
        }
        .list {
          a {
            display: block;
            margin: 15px 0;
            line-height: 14px;
            font-size: 14px;
            color: #333;
          }
        }
      }
      .m-group {
        overflow: hidden;
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 16px;
            font-weight: 600;
            color: #333;
          }
          .more {
            display: flex;
            color: #666;
            font-size: 14px;
            align-items: center;
            cursor: pointer;
            img {
              width: 16px;
              height: 16px;
              margin-bottom: 3px;
            }
          }
        }
        .grid-content {
          display: flex;
          padding: 16px 0;
          border-bottom: 1px solid #f1f1f1;
          &:last-child {
            border: 0;
            padding-bottom: 0;
          }
          .img {
            width: 70px;
            height: 70px;
            img {
              display: block;
              width: 70px;
              height: 70px;
              border-radius: 4px;
              border: 1px solid #e7e7e7;
            }
          }
          .content {
            margin-left: 15px;
            flex: 1;
            .name {
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              font-size: 14px;
              color: #20242a;
              margin-bottom: 4px;
              font-weight: 500;
            }
            .message {
              display: flex;
              align-items: center;
              font-size: 13px;
              color: #8c8c8c;
              .comment {
                margin-right: 8px;
              }
            }
          }
        }
      }
      .myPost {
        margin-top: 16px;
      }
    }
  }
}
.el-tabs-commounity {
  /deep/ {
    .el-icon-arrow-left,
    .el-icon-arrow-right {
      font-size: 16px;
      font-weight: bold;
      vertical-align: -2px;
    }
  }
}
</style>
